// BETA-ONLY: Remove this feature when beta ends

import type { QuestionOption } from '../types/betaProfile';

interface SingleSelectGroupProps {
  options: QuestionOption[];
  value: string | null;
  onChange: (value: string) => void;
  columns?: number;
}

export function SingleSelectGroup({
  options,
  value,
  onChange,
  columns = 2,
}: SingleSelectGroupProps): JSX.Element {
  return (
    <div
      className="grid gap-2"
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={`
            p-3 rounded-lg border-2 text-left text-sm transition-all
            ${value === option.value
              ? 'bg-evergreen/10 text-evergreen border-evergreen font-semibold'
              : 'bg-white text-ink border-soft-neutral hover:border-evergreen/50'
            }
          `}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
